import { useScheduleStartEvent } from './useScheduleStartEvent'

export const useScheduleAdsCampaign = (): void => {
  useScheduleStartEvent()
}
